export default "__VITE_ASSET__CLXxP7WF__"